import React from 'react';
import { Router } from '~/utils';

import { InfoPage } from './InfoPage';
import { InfoIndex } from './InfoIndex';
import { SystemInfo } from './SystemInfo';
import { Keys } from './Keys';

export default function InfoRoutes( props ) {
  return (
    <Router id="info-router">
      <InfoIndex path="/" />
      <SystemInfo path="system" />
      <Keys path="keys" />
      <InfoPage path=":id" />
    </Router>
  );
}
